<template>
  <div>
    <icon name="thumbs-up" scale="3.5"></icon>
    <p class="u-font-lg u-row-space-2" v-html="message"></p>
    <p v-if="canCloseApp">
      <button class="button s-vam" v-on:click="closeApp()" :title="$t('close_app')">
        <icon name="close" scale="0.75"></icon>&nbsp;
        <span>{{ $t('close') }}</span>
      </button>
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      bookTitle: {
        type: String,
        default: null
      }
    },

    computed: {
      message () {
        if (this.bookTitle) {
          return this.$i18n.t('book_returned_successfully_with_booktitle', { title: this.bookTitle })
        } else {
          return this.$i18n.t('book_returned_successfully')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/app_messages/SuccessfullyReturned.vue